export default __webpack_public_path__ + "static/media/photo--lg--kickoff4.282dfe03.jpg";